import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "src/components/Loading/Loading";
import { supabaseClient } from "src/lib/supabase/supabaseClient";

const MagicLinkCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    supabaseClient.auth.getSession().then(({ data }) => {
      if (data.session) {
        navigate("/auth-queue", { replace: true });
      } else {
        navigate("/login", { replace: true });
      }
    });
  }, [navigate]);
  return <Loading />;
};

export default MagicLinkCallback;
